var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeUnionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C14.0899 20 17 17.0899 17 13.5C17 9.91015 14.0899 7 10.5 7C6.91015 7 4 9.91015 4 13.5C4 17.0899 6.91015 20 10.5 20Z",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 24.5C2.64648 23.105 3.98241 21.9705 5.5244 21.1884C7.06639 20.4064 8.77102 19.9988 10.5 19.9988C12.229 19.9988 13.9336 20.4064 15.4756 21.1884C17.0176 21.9705 18.3535 23.105 19.375 24.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20C23.2291 19.9985 24.9342 20.4052 26.4764 21.1872C28.0186 21.9692 29.3544 23.1042 30.375 24.5",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8276 7.2175C20.7211 6.98038 21.6548 6.93655 22.5666 7.08893C23.4783 7.24132 24.347 7.58641 25.1148 8.10119C25.8826 8.61596 26.5317 9.28858 27.0189 10.0741C27.5061 10.8597 27.8202 11.7401 27.9401 12.6567C28.06 13.5733 27.9831 14.5049 27.7144 15.3893C27.4457 16.2738 26.9914 17.0908 26.382 17.7858C25.7725 18.4807 25.0218 19.0377 24.1799 19.4196C23.3381 19.8014 22.4245 19.9993 21.5001 20",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeUnionActive);
export default __webpack_public_path__ + "static/media/freeUnionActive.27f1470e87950a0e30210b48fde7a1be.svg";
export { ForwardRef as ReactComponent };